<!--
 * @Author: xiaokun
 * @Date: 2020-04-11 10:29:30
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-21 16:34:23
 * @Description: 试题管理 右侧 试题列表
 -->
<template>
  <div
    ref="paperQuestion"
    class="right-test-question"
  >
    <back-to-top @to-top="onToTop" />

    <div
      v-for="(item,index) in questions"
      :key="item._id"
      class="question-list"
    >
      <question-item
        :position="getItemPosition(index)"
        :questions-length="questions.length"
        :item-data="item"
        @on-move-item-click="handleMoveItem(index,$event)"
      >
        <span slot="question-serial-number">{{ index+1 }}、</span>
      </question-item>
    </div>
    <!-- 从话术库导入模块 -->
    <div class="guide-question border-attribute">
      <mk-button-biz
        class="guide-question-btn"
        width="171px"
        height="32px"
        @click="handleOnGuideQuestionClick"
      >
        <mk-iconfont icon-class="xinzeng" />
        <span class="guide-question-btn-text">从话术库导入题目</span>
      </mk-button-biz>
    </div>

    <!-- 导入弹窗 -->
    <guide-question-drawer
      ref="guideQuestionDrawer"
      :visible="visible"
      :choose-question-list="chooseQuestionList"
      @on-close-drawer="handleOnCloseDrawer"
      @on-select-question="getSelectQustionList"
    />
  </div>
</template>
<script>
import QuestionItem from '../question-item/index'
import GuideQuestionDrawer from '../guide-question-drawer'
import { mapMutations } from 'vuex'
import BackToTop from '@components/back-to-top'
export default {
  name: 'RightTestQuestion',
  components: { QuestionItem, GuideQuestionDrawer, BackToTop },
  props: {},
  data () {
    return {
      // 问题数组
      questions: [],
      visible: false
    }
  },
  computed: {
    chooseQuestionList () {
      let arr = []
      if (this.questions instanceof Array) {
        this.questions.forEach(item => {
          arr.push(item.sId)
        })
      }
      return arr
    },
    // 当前总题数
    curTotalNumber () {
      return this.$store.state['examination-manage'].curTotalNumber
    },
    // 当前相同分数分数
    curSameScore () {
      return this.$store.state['examination-manage'].curSameScore
    }
  },
  watch: {
    // 监听相同分输入
    curSameScore (cur, old) {
      if (cur && cur !== old) {
        this.questions.map(item => {
          item.score = cur
        })
        this.curPaperTotalScore(cur * this.curTotalNumber)
      }
    },
    // 在有相同分的情况下 监听题目总数变化
    curTotalNumber (cur, old) {
      if (cur !== old && this.curSameScore) {
        this.questions.map(item => {
          item.score = this.curSameScore
        })
        this.curPaperTotalScore(this.curSameScore * cur)
      }
    }
  },
  created () {},
  mounted () {},
  methods: {
    // 存入实时 计算总数
    ...mapMutations('examination-manage', {
      curPaperTotalScore: 'SET_CURPAPERTOTALSCORE',
      setCurTotalNumber: 'SET_CURTOTALNUMBER'
    }),
    handleOnGuideQuestionClick () {
      if (this.questions.length === 100) {
        this.$message.error('试题最多可添加100项')
      } else {
        this.visible = true
      }
    },
    // 编辑时 父级数据回显
    setData (data) {
      this.questions = data.questions
    },
    // 关闭导入库
    handleOnCloseDrawer () {
      this.visible = false
    },
    // 获取 导入数据
    getSelectQustionList (val) {
      if (val.length + this.questions.length > 100) {
        // 当前所选与已选数据相加大于100时
        this.$message.error('试题最多可添加100项')
      } else {
        val.forEach((item) => {
          this.questions.push({
            sId: item._id,
            title: item.title,
            score: undefined,
            answer: { type: 1, content: item.answer }
          })
        })
        this.setCurTotalNumber(this.questions.length)
        // 导入成功后清空 遮罩所选数组
        this.$refs.guideQuestionDrawer.clearSelection()
        this.visible = false
      }
    },
    // 表单提交事件，获取数据
    submitFormReturnQuestions () {
      return this.questions
    },
    // 获取 第一项
    getItemPosition (index) {
      if (index === 0) {
        return 'first'
      } else if (index === this.questions.length - 1) {
        return 'last'
      } else {
        return 'center'
      }
    },
    // 移动每一项的方法
    handleMoveItem (index, event) {
      let temp = JSON.parse(JSON.stringify(this.questions))
      if (event === 'up') {
        [temp[index - 1], temp[index]] = [temp[index], temp[index - 1]]
      } else if (event === 'down') {
        [temp[index], temp[index + 1]] = [temp[index + 1], temp[index]]
      } else if (event === 'delete') {
        // bug#3105 避免数据被删后 导入框仍为选中未反显状态
        this.$refs.guideQuestionDrawer.clearSelection()
        temp.splice(index, 1)
        this.setCurTotalNumber(temp.length)
      } else if (event === 'update') {
        let total = 0
        temp.map(item => {
          total = total + (item.score || 0)
        })
        this.curPaperTotalScore(total)
      }
      this.questions = temp
    },
    // 实时计算当前 总分数 用于左侧试卷信息组件展示
    getTotalScore () {
      let score = 0
      this.questions.forEach(item => {
        score = score + (item.score || 0)
      })
      // 将分数存入vuex 左侧从vuex中获取
      this.curPaperTotalScore(score)
    },
    // 回到顶部
    onToTop () {
      this.$refs.paperQuestion.scrollTop = 0
    }
  }
}
</script>
<style lang='scss' scoped>
.right-test-question {
  width: 100%;
  height: calc(100vh - 255px);
  overflow-y: scroll;

  .guide-question {
    height: 128px;
    display: flex;
    align-items: center;
    justify-content: center;

    .guide-question-btn {
      padding: 8px 16px;
      border: 1px solid rgba(204, 236, 255, 1);
      color: #1b9aee;

      .icon-mk-xinzeng {
        color: #1b9aee;
        font-size: 13px;
      }

      .guide-question-btn-text {
        padding-left: 8px;
      }
    }
  }
}
</style>
